import React from 'react';
import { Space, Row, Col } from 'antd';
import { useDashboard } from '../hooks/useDashboard';
import { DashboardHeader } from '../components/DashboardHeader';
import { KPISection1, KPISection2 } from '../components/KPISection';
import { AnalyticsSection } from '../components/AnalyticsSection';
import { MerchantBillingTable } from '../components/MerchantBillingTable';
import { RecentTransactions } from '../components/RecentTransactions';
import { FinancialDetailsSection } from '../components/FinancialDetailsSection';

export const DashboardPage: React.FC = () => {
    const {
        isComparing,
        setIsComparing,
        trendTimeframe,
        setTrendTimeframe,
        dateRange,
        setDateRange,
        compareDateRange,
        setCompareDateRange,
        isFilterDrawerOpen,
        setIsFilterDrawerOpen,
        compareLabel,
        handleDownloadReport
    } = useDashboard();

    return (
        <Space direction="vertical" size="middle" style={{ width: '100%', paddingBottom: 24 }}>
            <DashboardHeader
                dateRange={dateRange}
                setDateRange={setDateRange}
                isComparing={isComparing}
                setIsComparing={setIsComparing}
                compareDateRange={compareDateRange}
                setCompareDateRange={setCompareDateRange}
                handleDownloadReport={handleDownloadReport}
            />

            <KPISection1 
                dateRange={dateRange} 
                compareDateRange={compareDateRange} 
                isComparing={isComparing} 
                compareLabel={compareLabel} 
            />

            <AnalyticsSection
                trendTimeframe={trendTimeframe}
                setTrendTimeframe={setTrendTimeframe}
                dateRange={dateRange}
                compareDateRange={compareDateRange}
                isComparing={isComparing}
                compareLabel={compareLabel}
            />

            <Row gutter={[16, 16]}>
                <Col span={16}>
                    <MerchantBillingTable
                        dateRange={dateRange}
                        isFilterDrawerOpen={isFilterDrawerOpen}
                        setIsFilterDrawerOpen={setIsFilterDrawerOpen}
                    />
                </Col>
                <Col span={8}>
                    <RecentTransactions dateRange={dateRange} />
                </Col>
            </Row>

            <KPISection2 isComparing={isComparing} compareLabel={compareLabel} />

            <FinancialDetailsSection
                dateRange={dateRange}
                isComparing={isComparing}
                compareLabel={compareLabel}
            />
        </Space>
    );
};
